import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import flow from './modules/flow'
import charset from './modules/charset'
function listToMap(list, k = '') {
  const map = {}
  list.forEach((v, i) => {
    map[k + i] = v
  })
  return map
}
const store = new Vuex.Store({
  state: {
    funSteps: [],  //列表
    funStepsMap: {},
    itemSteps: {
      $if: null,
      ifDo: null,
      $else: null,
      elseDo: null,
      elseIf: [], //array
      elseIfDo: [], //array
      elseIfMap: {},
      elseIfDoMap: {}
    },  // if else编辑数据
    itemMapping: null,
    funOpts: null,  //选项
    funOptsMap: {},
    stepEdit: false,
  },
  modules:{
      flow,
      charset
  },
  mutations: {
    stepEditStatusChange(state) {
      state.stepEdit = true
    },
    stepEditStatusDefault(state) {
      state.stepEdit = false
    },
    dataInit(state) {
      state.funSteps = []
      state.funStepsMap = {}
      state.iteSteps = {
        $if: null,
        ifDo: null,
        $else: null,
        elseDo: null,
        elseIf: [],
        elseIfDo: [],
        elseIfMap: {},
        elseIfDoMap: {}
      }
      state.itemMapping = null
    },
    FunSteps (state, {list, map}) {
      state.funSteps = list
      state.funStepsMap = map
    },
    FunStepItem (state, v) {
      state.funSteps.push(v)
      v._index = v.sort - 1
      state.funStepsMap[v._index] = v
    },
    UpdateFunStepItem (state, {kid, item}) {
      state.funSteps.splice(kid, 1, item)
      state.funStepsMap[kid] = item
    },
    ItemMapping (state, v) {
      state.itemMapping = v
    },
    FunOpts (state, {list, map}) {
      state.funOpts = list
      state.funOptsMap = map
    },
    // if、do等数据操作
    ItemSteps (state, value) {
      // state.itemSteps = value
      state.itemSteps = JSON.parse(JSON.stringify(value))
      console.log(state.itemSteps)
    },
    ItemStepsForKey (state, {key, value}) {
      if (value.subSteps) value._map = listToMap(value.subSteps)
      state.itemSteps[key] = value
      if (key === 'elseIf') {
        state.itemSteps.elseIfMap = listToMap(value, 'if-')
      } else if (key === 'elseIfDo') {
        state.itemSteps.elseIfDoMap = listToMap(value, 'do-')
      }
    },
    // if、do等下面的subSteps数据操作(增、删、改)
    ItemStepsChild (state, {key, list}) {
      if (state.itemSteps[key]) {
        // 数据结构问题 处理兼容
        if (key.indexOf('if-') !== -1) {
          state.itemSteps.elseIfMap[key]._map = listToMap(list)
          state.itemSteps.elseIfMap[key].subSteps = list
        } else if (key.indexOf('do-') !== -1) {
          state.itemSteps.elseIfDoMap[key]._map = listToMap(list)
          state.itemSteps.elseIfDoMap[key].subSteps = list
        } else {
          state.itemSteps[key]._map = listToMap(list)
          state.itemSteps[key].subSteps = list
        }
      }
    },
    ItemStepsAddChild (state, {key, item, belongIndex}) {
      if (key === 'elseIf') {
        const list = state.itemSteps.elseIf[belongIndex].subSteps || []
        list.push(item)
        /*state.itemSteps.elseIfMap[key]._map = listToMap(list)
        state.itemSteps.elseIfMap[key].subSteps = list*/
        state.itemSteps.elseIf[belongIndex].subSteps = list
      } else if (key === 'elseIfDo') {
        const list = state.itemSteps.elseIfDo[belongIndex].subSteps || []
        list.push(item)
        /*state.itemSteps.elseIfDoMap[key]._map = listToMap(list)
        state.itemSteps.elseIfDoMap[key].subSteps = list*/
        state.itemSteps.elseIfDo[belongIndex].subSteps = list
      } else {
        const list = state.itemSteps[key].subSteps
        list.push(item)
        state.itemSteps[key]._map = JSON.parse(JSON.stringify(listToMap(list)))
        state.itemSteps[key].subSteps = JSON.parse(JSON.stringify(list))
      }
    },
    ItemStepsDelChild (state, {key, index, belongIndex}) {
      if (state.itemSteps[key]) {
        if (key === 'elseIf') {
          const list = state.itemSteps.elseIf[belongIndex].subSteps
          list.splice(index, 1)
          /*state.itemSteps.elseIfMap[key]._map = listToMap(list)
          state.itemSteps.elseIfMap[key].subSteps = list*/
          state.itemSteps.elseIf[belongIndex].subSteps = list
        } else if (key === 'elseIfDo') {
          const list = state.itemSteps.elseIfDo[belongIndex].subSteps
          list.splice(index, 1)
          list.forEach(item => {
            if (item.sort > index + 1) {
              item.sort = item.sort - 1
            }
          })
          /*state.itemSteps.elseIfDoMap[key]._map = listToMap(list)
          state.itemSteps.elseIfDoMap[key].subSteps = list*/
          state.itemSteps.elseIfDo[belongIndex].subSteps = list
        } else {
          const list = state.itemSteps[key].subSteps
          list.splice(index, 1)
          list.forEach(item => {
            if (item.sort > index + 1) {
              item.sort = item.sort - 1
            }
            if (item.handlerType === 1) {
              let itemStepParams = item.mappingHandleStepParams
              if (itemStepParams.length > 0) {
                itemStepParams.forEach(itemParam => {
                  if (itemParam.inputSourceType === 3 && item.sort < itemParam.value) {
                    itemParam.value = (itemParam.value - 1).toString()
                  }
                })
              }
            }
          })
          state.itemSteps[key]._map = listToMap(list)
          state.itemSteps[key].subSteps = list
        }
      }
    },
    ItemStepsUpdateChild (state, {key, index, item}) {
      if (state.itemSteps[key]) {
        if (key.indexOf('if-') !== -1) {
          const list = state.itemSteps.elseIfMap[key].subSteps
          list.splice(index, 1, item)
          state.itemSteps.elseIfMap[key]._map = listToMap(list)
          state.itemSteps.elseIfMap[key].subSteps = list
        } else if (key.indexOf('do-') !== -1) {
          const list = state.itemSteps.elseIfDoMap[key].subSteps
          list.splice(index, 1, item)
          state.itemSteps.elseIfDoMap[key]._map = listToMap(list)
          state.itemSteps.elseIfDoMap[key].subSteps = list
        } else {
          const list = state.itemSteps[key].subSteps
          list.splice(index, 1, item)
          state.itemSteps[key]._map = listToMap(list)
          state.itemSteps[key].subSteps = list
        }
      }
    },
    itemStepsDataInit(state) {
      state.itemSteps.elseIf = []
      state.itemSteps.elseIfDo = []
      state.itemSteps.$else = null
      state.itemSteps.elseDo = null
      state.itemSteps.elseIfMap = {}
      state.itemSteps.elseIfDoMap = {}
    },
  },
  actions: {
    setFunSteps ({commit, state}, list) {
      commit('FunSteps', {list, map: listToMap(list)})
    },
    addFunStepItem ({commit, state}, item) {
      commit('FunStepItem', item)
    },
    updateFunStepItem ({commit, state}, {kid, item}) {
      commit('UpdateFunStepItem', {kid, item})
    },
    delFunStepItem ({commit, state}, item) {
      // debugger
      const list = state.funSteps
      const funStepsCount = list.length
      list.splice(item.sort - 1, 1)

      list.forEach(itemAfterDel => {
        if (itemAfterDel.sort > item.sort) {
          itemAfterDel.sort = itemAfterDel.sort - 1
          // itemAfterDel._index = itemAfterDel._index - 1
        }

        if (itemAfterDel.handlerType === 1) { // normal fn
          let itemStepParams = itemAfterDel.mappingHandleStepParams

          if (itemStepParams.length > 0) {
            itemStepParams.forEach(itemParam => {
              if (itemParam.inputSourceType === 3 && item.sort < itemParam.value) {
                itemParam.value = (itemParam.value - 1).toString()
              }
            })
          }
        } else { // if..else fn
          let subSteps = itemAfterDel.subSteps

          if (subSteps.length > 0) {
            subSteps.forEach(itemStepSub => {
              if (itemStepSub.handlerType === 3 || itemStepSub.handlerType === 5) {
                let condition = itemStepSub.subSteps
                condition.forEach(itemCondition => {
                  if (itemCondition.boolExpression.leftType === 2) {
                    if (item.sort < itemCondition.boolExpression.leftValue) {
                      itemCondition.boolExpression.leftValue = (itemCondition.boolExpression.leftValue - 1).toString()
                    }
                  }

                  if (itemCondition.boolExpression.rightType === 2) {
                    if (item.sort < itemCondition.boolExpression.rightValue) {
                      itemCondition.boolExpression.rightValue = (itemCondition.boolExpression.rightValue - 1).toString()
                    }
                  }
                })
              }
            })
          }
        }
      })
      console.log(state.funSteps)
      commit('FunSteps', {list, map: listToMap(list)})
    },
    setItemMapping ({commit, state}, value) {
      commit('ItemMapping', value)
    },
    setFunOpts ({commit, state}, list) {
      const map = {}
      list.forEach(v => {
        map[v.id] = v
      })
      commit('FunOpts', {list, map: map})
    },
    // if、do等数据操作
    setItemSteps ({commit, state}, list) {
      const elseIf = [], elseIfDo = []
      let $if = null, ifDo = null, $else = null,
        elseDo = null, elseIfMap, elseIfDoMap, type
      list.forEach((v, i) => {
        if (v.subSteps) v._map = listToMap(v.subSteps)
        if (v.handlerType === 4) {
          switch (type) {
            case 3:
              ifDo = v
              break
            case 6:
              elseDo = v
              break
            case 5:
              elseIfDo.push(v)
              break
          }
        } else {
          switch (v.handlerType) {
            case 3:
              type = 3
              $if = v
              break
            case 6:
              type = 6
              $else = v
              break
            case 5:
              type = 5
              elseIf.push(v)
              break
          }
        }
      })
      elseIfMap = listToMap(elseIf, 'if-')
      elseIfDoMap = listToMap(elseIfDo, 'do-')
      commit('ItemSteps', {$if, ifDo, elseIf, elseIfDo, $else, elseDo, elseIfMap, elseIfDoMap})
    },
    setItemStepsForKey ({commit, state}, {key, value}) {
      commit('ItemStepsForKey', {key, value})
    },
    // if、do等下面的subSteps数据操作(增、删、改)
    setItemStepsChild ({commit, state}, {key, list}) {
      commit('ItemStepsChild', {key, list})
    },
    setItemStepsAddChild ({commit, state}, {key, item, belongIndex}) {
      commit('ItemStepsAddChild', {key, item, belongIndex})
    },
    setItemStepsDelChild ({commit, state}, {key, index, belongIndex}) {
      commit('ItemStepsDelChild', {key, index, belongIndex})
    },
    setItemStepsUpdateChild ({commit, state}, {key, index, item}) {
      commit('ItemStepsUpdateChild', {key, index, item})
    },
    setStoreDataInit({commit, state}) {
      commit('dataInit')
    },
    setStepEditStatusDefault({commit, state}) {
      commit('stepEditStatusDefault')
    },
    setStepEditStatus({commit, state}) {
      commit('stepEditStatusChange')
    },
    clearItemSteps({commit, state}) {
      commit('itemStepsDataInit')
    },
  },
  getters: {
    getFunSteps: state => state.funSteps,
    getFunStepsMap: state => state.funStepsMap,
    getItemMapping: state => state.itemMapping,
    getFunOpts: state => state.funOpts,
    getFunOptsMap: state => state.funOptsMap,
    getItemSteps: state => state.itemSteps
  }
})
export default store



// WEBPACK FOOTER //
// ./src/stores/index.js